const RadioGroup = ({ name, options, selectedOption, onChange, disabled = false }) => {
  return (
    <div>
      {options.map((option) => (
        <label key={option.value} style={{ fontWeight: "none !important", opacity: disabled ? 0.5 : 1 }}>
          <input
            style={{ marginLeft: "5px" }}
            type="radio"
            name={name}
            value={option.value}
            checked={selectedOption == option.value}
            onChange={onChange}
            disabled={disabled}
          />
          {option.label}
        </label>
      ))}
    </div>
  );
};

export default RadioGroup;
